import { RawAxiosRequestHeaders } from 'axios'

export function removeAllHeaders(headers: RawAxiosRequestHeaders) {
  Object.keys(headers).forEach((key) => {
    delete headers[key]
  })

  return headers
}
